import { SubscriptionRequest } from "@somewear/api";
import { createSelector } from "reselect";

import type { SubscriptionState } from "./subscription.state";
import { selectAllSubscriptions } from "./subscriptionsSlice";

export const subscriptionsSelector = (state: SubscriptionState): SubscriptionRequest.AsObject[] => {
	return selectAllSubscriptions(state);
};

export const isPaidUserSelector = createSelector([subscriptionsSelector], (subscriptions) =>
	Object.values(subscriptions)
		.filter((subscription) => subscription.plan !== SubscriptionRequest.Plan.NONE)
		.isNotEmpty(),
);
